import {NgModule} from '@angular/core';


 
import {RouterModule} from '@angular/router';
import {ChannelsPageComponent} from './channels-page.component' 
import {ChannelsHeaderComponent} from './components/header/channels-header.component'
import {SharedModule} from '../shared/shared.module';
 


import {ChannelPageComponent} from './pages/channel/channel-page.component'


import {NumberSpacedPipe} from '../shared/classes/number-spaced.pipe'
//import {AdditionPercentagePipe} from '../shared/classes/addition-percentage.pipe';

@NgModule({
  declarations:[
    // ChannelsHeaderComponent,
    ChannelsPageComponent,
    ChannelPageComponent,
 
	NumberSpacedPipe
	//AdditionPercentagePipe
], 
  imports:[

   SharedModule,
	//NumberSpacedPipe,
     RouterModule.forChild([
      {path: '',   children: [
        {path:'', component: ChannelsPageComponent}, 
        {path: ':url', component: ChannelPageComponent},

      ]},
    ]) 
  ],
  exports:[
     NumberSpacedPipe
//AdditionPercentagePipe,
   // ChannelsHeaderComponent,
   // ChannelsPageComponent,
  //  ChannelPageComponent
  ]
})


export class ChannelsModule {

}
